import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// sushi
import Input from 'sushiweb/InputTypes/Input';
import H6 from 'sushiweb/Typography/Heading/H6';
import Layout from 'sushiweb/Layout';
import grey from 'sushiweb/tokens/color/grey';

const StyledLayout = styled(Layout)`
  margin-bottom: calc(2rem + ${props => props.mb});
`;

const Item = styled(Layout.Item)``;

const Label = styled(H6)`
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 1rem;
`;

const Value = styled(Input)`
  margin-left: 1rem;
  padding-bottom: 0;
`;

const Helper = styled(Input.Helper)`
  color: ${grey.z600};
  margin-left: 1rem;
  position: absolute;
`;

function ReviewRow({ label, value, helperText, gap }) {
  return (
    <StyledLayout mb={gap}>
      <Item colD={6} colT={6} colM={12}>
        <Label>
          {label}
          {' '}
          :
        </Label>
      </Item>
      <Item colD={6} colT={6} colM={12}>
        <Value label='' value={value} disabled showHelperText={false} />
        <Helper>{helperText}</Helper>
      </Item>
    </StyledLayout>
  );
}

ReviewRow.propTypes = {
  label: PropTypes.string.isRequired,
  gap: PropTypes.string,
  helperText: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
ReviewRow.defaultProps = {
  helperText: '',
  gap: '0rem',
};

export default ReviewRow;
